import createClass from 'create-react-class';
import React, { Component } from 'react';
import up from 'react-addons-update';
import ClickOutsideMixins from 'react-onclickoutside';
import Tooltip from 'react-tooltip';

import TranslateManager from 'ts-translate-js';
const tr = TranslateManager.boundTR;

// Uses window.tsapp
var ctl = tsapp.ctl;

// TODO: Center the scroll when clicking on the new payment form?

// methods: payment methods[], onMethodSelect(isValid, selectedMethod, data), onMethodDelete(methodToDelete)
export const PaymentMethodList = createClass({
    displayName: "PaymentMethodList",

    getInitialState: function() {
        return {
            selectedToken: this.props.methods[0].token,
            processing: false,
            lastError: "",
            newCardInfo: {}
        };
    },
    getDefaultProps: function(){
        return {
            supportsCVVNumber: false
        };
    },
    handleSelect: function(itemToken) { this.setState({  selectedToken: itemToken }); },
    handlePay: function(method, data) {
        var _this = this;
        this.props.onProcessPayment({
            setProcessing: function() {
                _this.setState({ processing: true });
            },
            error: function(error){
                _this.setState({ processing: false, lastError: status });
            },
        }, method, data);
    },
    handleBack: function(){
        this.setState({ processing: true });
    },
    handleNewCardChange: function(newCardInfo){
        this.setState({ newCardInfo: newCardInfo });
        console.log(newCardInfo);
    },
    render: function(){
        
        var _this = this;
        var getInnerCtl = function(item) {
            var selected = item.token == _this.state.selectedToken;
            if(item.isCreditCard)
                return <CreditCardPaymentMethod method={item} amount={_this.props.amount} selected={selected} processing={_this.state.processing} onPay={_this.handlePay} onBack={_this.handleBack} />;
            else
                return <NewCreditCardPaymentMethod method={item} cardInfo={_this.state.newCardInfo}  onChange={_this.handleNewCardChange} amount={_this.props.amount} selected={selected} processing={_this.state.processing} supportsCVVNumber={_this.props.supportsCVVNumber} onPay={_this.handlePay} onBack={_this.handleBack} />;
        }
        
        return (
            <div>
                <ctl.SelectableList items={this.props.methods} getId={function(item) { return item.token; }} getInnerCtl={getInnerCtl} onSelect={this.handleSelect} />
            </div>
        );
        
    }
});


export const CreditCardPaymentMethod = createClass({
    displayName: "CreditCardPaymentMethod",

    handleDelete: function() {
        if(confirm("Voulez-vous vraiment supprimer ce mode de paiement?"))
            console.log("Delete");
        else
            console.log("No delete");
    },
    handlePay: function(){
        this.props.onPay(this.props.method);
    },
    render: function(){
        var method = this.props.method;
        var cardClassMapping = { "MasterCard": "mastercard", "Visa": "visa" };

        var payButton;
        if(this.props.selected)
            payButton = (
                <div className="row">
                    <PaymentButtons amount={this.props.amount} processing={this.props.processing} onPay={this.handlePay} onBack={this.props.onBack} />
                </div>
            );

        var deleteButton;
        if(!this.props.processing)
            deleteButton = <a onClick={this.handleDelete}><span className="glyphicon glyphicon-trash"></span></a>;
        
        return (
            <div>
                <div className={"row cardPaymentMethod " + cardClassMapping[method.cardType]}>
                    <div className="col-xs-12">
                        <div className="cardImg pull-left"></div>
                        <div className="pull-left">
                            <span>{this.props.method.cardType} </span>
                            <span className="text-muted">{tsapp.tr('creditcard.endingWith', { number: this.props.method.lastDigits })}</span>
                        </div>
                        <div className="pull-right">
                            {deleteButton}
                        </div>
                    </div>
                </div>
                {payButton}
            </div>
        )
    }
});

export const NewCreditCardPaymentMethod = createClass({
    displayName: "NewCreditCardPaymentMethod",

    handlePay: function(){
        this.props.onPay(this.props.method, this.props.cardInfo);
    },
    render: function(){
        var ctlToShow;
        var payButton;
        if(this.props.selected){
            ctlToShow = <NewCreditCardForm {...this.props} />;
            payButton = <PaymentButtons amount={this.props.amount} processing={this.props.processing} onPay={this.handlePay} onBack={this.props.onBack} />;
        }
        else
            ctlToShow = <div>{tr("Autre methode")}</div>;
        
        return (
            <div>
                {ctlToShow}
                {payButton}
            </div>
        )
    }
});

export const NewCreditCardForm = createClass({
    displayName: "NewCreditCardForm",

    handleChange: function(e) {
        var changes = {};
        changes[e.target.name] = { $set: e.target.value };
        this.props.onChange( up(this.props.cardInfo, changes) ); // Trigger to parent
    },
    render: function() {
        var cardInfo = this.props.cardInfo;

        var cvvNumberField;
        if(this.props.supportsCVVNumber){
            var cardCVVHelpLink = <WhereToFindCVVLink />;
            cvvNumberField = <ctl.FormTextGroup name="cardCVV" value={cardInfo.cardCVV} onChange={this.handleChange} bootstrap="col-xs-5 col-md-3" label={tsapp.tr("creditcard.verificationNumber")} help={cardCVVHelpLink} />;
        }

        return (
            <form className="" action="">
                <ctl.FormTextGroup name="cardHolderName" value={cardInfo.cardHolderName}  onChange={this.handleChange} ref="inputToFocus" label={tsapp.tr("creditcard.cardHolderName")} />
                <ctl.FormTextGroup name="cardNumber" value={cardInfo.cardNumber} onChange={this.handleChange} label={tsapp.tr("creditcard.cardNumber")} help={tsapp.tr("creditcard.withoutSpaces")} />
                <ctl.FormGroup label={tsapp.tr("creditcard.expirationDate")} help={this.props.help}>
                    <ctl.MonthSelector name="cardExpMonth" value={cardInfo.cardExpMonth} onChange={this.handleChange} bootstrap="col-xs-4" />
                    <ctl.YearSelector name="cardExpYear" value={cardInfo.cardExpYear} onChange={this.handleChange} bootstrap="col-xs-4" />
                </ctl.FormGroup>
                {cvvNumberField}
                <div className="text-info">
                    <ctl.FormCheckbox name="saveCardForNextTimes" checked={cardInfo.saveCardForNextTimes} onChange={this.handleChange}  label={tsapp.tr("creditcard.rememberForNextPurchases")} />
                </div>
            </form>
        );
    },
    componentDidMount: function() {
        this.refs.inputToFocus.focus();
    }
});

export const PaymentButtons = createClass({
    displayName: "PaymentButtons",

    render: function() {
        var processingMsg, buttons;
        if(this.props.processing)
            processingMsg = <strong>{tsapp.tr('browsing.processing')}</strong>;
        else{
            buttons = (
                <div className="btn-toolbar pull-right">
                    <button className="btn btn-default" onClick={this.props.onBack}>{tsapp.tr('browsing.back')}</button>
                    <button className="btn btn-primary" onClick={this.props.onPay}>
                        {tsapp.tr('payment.pay')} <span className="badge">{this.props.amount}</span>
                    </button>
                </div>
            );
        }
        
        return (
            <div className="col-xs-12">
                {buttons}
                {processingMsg}
            </div>
        )
    }
});

export class WhereToFindCVVLink extends Component {
    constructor(props) {
        super(props);
        
        this.mixins = [
            ClickOutsideMixins
        ];
    }

    mouseClick(e) { e.target.tooltip.showTooltip(e); } // TODO - Check this function
    
    handleClickOutside(e) { Tooltip.hide(); }
    
    render() {
        var amex;
        if(this.props.amexSupported)
            amex = (
                <div>
                    <h3>{tr("American Express")}</h3>
	                <img src="../../img/cvv/CIDSampleAmex.png" alt="" />
                </div>
            );
        
        var infoPanel = (
            <div>
	            <div>
                    <h3>{tsapp.tr('creditcard.masterCardAndVisa')}</h3>
	                <img src="../../img/cvv/CVC2SampleVisaNew.png" alt="" />
                </div>
	            {amex}
            </div>
        );

        return(
            <div style={{ position: 'relative' }}>
                <a data-tip data-for="cardCVVToolTip" onClick={this.mouseClick}>{tsapp.tr('creditcard.whereToFindIt')}</a>
                <Tooltip id="cardCVVToolTip" ref="tooltip" place="right" type="light">
                    {infoPanel}
                </Tooltip>
            </div>
        );
    }
};

WhereToFindCVVLink.defaultProps = {
    amexSupported: false
}

